<template lang="pug" >
	div#footer
		.grid.grid--middle
			.grid__cell(class="r1-2")
				ul.links
					li(v-for="item, key in menu")
						router-link( :to="item.anchor") {{ item.name }}
</template>

<script>
import store from './../../../store';

export default {
	name: 'Navfooter',
	computed:{
		menu(){
			return store.state.menu.footer;
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/features/Navfooter/index.vue